import { number } from "prop-types";
import SparePartRequestCreate from "../../pages/SparePartRequests/SparePartRequestCreate";
import {
  required,
  isEmail,
  isNumber,
  maxLength,
  minLength,
  isAlphabet,
  isPhoneNumber,
  isPassword,
  isChecked,
  isURL,
  isValidDate,
  isValidTime,
  isPath,
  isGST,
  isIconNameOrImage,
  isAlphanumeric,
  isCost,
} from "./Ruls";

export const validate = (formName, formData) => {
  const errors = {};

  const validationRules = {
    EnvironmentCreate: {
      environment: [required, isAlphabet, minLength(3)],
      email: [required, minLength(5), isEmail],
      age: [required, isNumber],
      firstName: [required, minLength(1), maxLength(10)],
      phoneNumber: [isPhoneNumber],
      password: [isPassword],
      is_active: [isChecked],
      active: [isChecked],
      url: [isURL],
      date: [required, isValidDate],
      duration: [isValidTime, required],
      media: [required],
      multiMedia: [required],
      multiModule: {
        type: [required],
        firstName: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName: [required, isAlphabet, minLength(1), maxLength(10)],
        age: [required, isNumber],
      },
      secondMultiModule: {
        type1: [required],
        firstName1: [required, isAlphabet, minLength(1), maxLength(10)],
        lastName1: [required, isAlphabet, minLength(1), maxLength(10)],
        age1: [required, isNumber],
      },
    },
    CountryCreate: {
      country_name: [required, isAlphabet],
    },
    StateCreate: {
      state_name: [required, isAlphabet],
      country_id: [required],
    },
    CityCreate: {
      city_name: [required, isAlphabet],
      state_id: [required],
      country_id: [required],
    },
    BranchCreate: {
      branch_name: [required, isAlphabet],
      city_id: [required],
      state_id: [required],
      country_id: [required],
    },
    MaterialCreate: {
      name: [required, isAlphabet],
      unit_cost: [required],
      category_id: [required],
      uom_id: [required],
      code: [required],
    },

    MaterialIntakesCreate: {
      material_id: [required],
      customer_id: [required],
      received_date: [required],
      status: [required],
    },

    SparePartRequestsCreate: {
      job_card_id: [required],
      spare_id: [required],
      status: [required],
      quantity: [required, isNumber],

      // issue_qty: [required, isNumber],
    },
    ScrapCreate: {
      intake_id: [required],
      scrap_reason_id: [required],
      job_card_id: [required],
      remark: [required],

      // issue_qty: [required, isNumber],
    },

    MaterialApproval: {
      inspected_at: [required],
    },

    WarehouseCreate: {
      project_id: [required],
      state_id: [required],
      city_id: [required],
      warehouse_name: [required],
      type: [required],
    },
    RoleCreate: {
      role_name: [required, isAlphabet],
    },
    JobCardCreate: {
      technician_check_at: [required],
      technician_check_remark: [required],
    },
    UOMCreate: {
      name: [required, isAlphabet],
    },
    CategoryCreate: {
      name: [required],
      material_type: [required, isNumber],
    },
    MenuCreate: {
      menu_name: [required, isAlphabet],
      menu_icon: [isIconNameOrImage],
      menu_url: [required, isPath],
      parent_id: [required],
    },
    ScrapReasonCreate: {
      reason: [required],
    },
    ItemCreate: {
      item_code: [required],
      description: [required],
      uom_id: [required],
      cost: [required, isCost],
      type: [required],
      origin: [required],
      category_id: [required],
    },
    UserCreate: {
      // user_type: [required],
      first_name: [required, isAlphabet],
      last_name: [required, isAlphabet],
      role_id: [required],
      branch_id: [required],
      email_id: [required, isEmail],
      mobile_number: [required, isPhoneNumber],
      password: [required, minLength(6)],
      username: [required, minLength(3)],
      // alt_mobile_number: [isPhoneNumber],
      // gst_no: [isGST],
      // company_id: [required],
      // subcontractor: {
      //   first_name: [required],
      //   last_name: [required],
      //   email_id: [required, isEmail],
      //   mobile_number: [required, isPhoneNumber],
      //   password: [required, minLength(6)],
      // },
      // user_documents: {
      //   document: [required],
      //   file: [required],
      // },
    },
    InstallationCreate: {
      project_id: [required],
      customer_id: [required],
      order_id: [required],
      form_name: [required],
      ref_document_no: [required, isAlphanumeric],
    },
    StageCreate: {
      stage: [required, isAlphabet],
    },
    GSTPercentageCreate: {
      gst_percentage: [required],
    },
    CommissioningCreate: {
      customer_id: [required],
      form_name: [required, isAlphanumeric],
      ref_document_no: [required, isAlphanumeric],
    },
    ProjectCreate: {
      project_code: [required],
      customer_id: [required],
      project_name: [required],
    },
  };

  const rulesForForm = validationRules[formName];

  if (!rulesForForm) {
    return errors;
  }

  const processValidation = (rules, data, parentKey = "") => {
    for (const field in rules) {
      const fieldRules = rules[field];
      const fieldValue = data[field];
      const fullKey = parentKey ? `${parentKey}.${field}` : field;

      if (Array.isArray(fieldRules)) {
        // Validate flat fields
        for (const rule of fieldRules) {
          const errorMessage = rule(fieldValue, field);
          if (errorMessage) {
            errors[fullKey] = errorMessage;
            break;
          }
        }
      } else if (Array.isArray(fieldValue)) {
        // Special case for arrays like multiModule
        fieldValue.forEach((row, index) => {
          // Process each object in the array
          processValidation(fieldRules, row, `${fullKey}[${index}]`);
        });
      } else if (typeof fieldRules === "object") {
        // Recurse into nested objects
        processValidation(fieldRules, fieldValue || {}, fullKey);
      }
    }
  };

  processValidation(rulesForForm, formData);

  return errors;
};
